// Umgebungsvariablen für V&B Live System
// der Build wird mit 'npm run build-prod' ausgeführt (siehe package.json)
export const environment = {
  apiBaseUrl: 'https://vb-dl-api.villeroy-boch.com',
  appVersion: require('../../package.json').version,
  production: true,
  servicePortal: 'https://www.vb-serviceportal.com',
};
